module.exports = __webpack_public_path__ + "img/united_kingdom_flag.adcd8ee6.svg";